import React from 'react';
import { FileSearchOutlined, SwapOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { CREATING, FROZEN, PAUSED, type Session } from 'state';

import { ordinaryTradeIsDisabled } from '../MarketsTabV3/model';
import type { MarketInstrument } from '../MarketsTabV3/types';

type Props = {
  row: MarketInstrument;
  session: Session;
  onTrade: () => void;
  onODA?: () => void;
  onDetails?: () => void;
  tradeOpen?: boolean;
  odaOpen?: boolean;
};

const stop = (callback: () => void) => (event: React.MouseEvent) => {
  event.stopPropagation();
  callback();
};

const InstrumentActions: React.FC<Props> = ({
  row,
  session,
  onTrade,
  onODA,
  onDetails,
  tradeOpen = false,
  odaOpen = false,
}) => {
  const tradeDisabled = ordinaryTradeIsDisabled({
    status: session.status,
    asset: row.asset,
    instrument: row.instrument,
    closedFromInterval: row.closedFromInterval,
  });
  const odaDisabled =
    session.status === PAUSED ||
    session.status === CREATING ||
    session.status === FROZEN ||
    !row.instrument.amount;

  return (
    <div className="markets-v2-actions markets-v4-action-grid">
      {onDetails && (
        <span className="markets-v4-action--details">
          <Tooltip title="Instrument details">
            <Button
              size="small"
              aria-label={`View ${row.asset.name || row.asset.ticker} details`}
              icon={<FileSearchOutlined />}
              onClick={stop(onDetails)}
            />
          </Tooltip>
        </span>
      )}
      {onODA && (
        <span className="markets-v4-action--oda">
          <Tooltip title="Open order automation">
            <span>
              <Button
                size="small"
                className={odaOpen ? 'is-in-desk' : ''}
                aria-pressed={odaOpen}
                disabled={odaDisabled}
                onClick={stop(onODA)}
              >
                ODA
              </Button>
            </span>
          </Tooltip>
        </span>
      )}
      <span className="markets-v4-action--trade">
        <Button
          size="small"
          type="primary"
          className={tradeOpen ? 'is-in-desk' : ''}
          aria-pressed={tradeOpen}
          icon={<SwapOutlined />}
          disabled={tradeDisabled}
          onClick={stop(onTrade)}
        >
          Trade
        </Button>
      </span>
    </div>
  );
};

export default InstrumentActions;
